export default "__VITE_ASSET__DofXjCLP__"